<template>
    <section class="content">
        <table class="table table-hover" ref="tableuser">
            <thead>
                <tr>
                    <th>Nama Sekolah</th>
                    <th>Alamat</th>
                    <th>Website</th>
                    <th>Telp Sekolah</th>
                    <th>Email Sekolah</th>
                    <th>Guru 1</th>
                    <th>Guru 2</th>
                    <th>Guru 3</th>
                    <th>Guru 4</th>
                </tr>
            </thead>
            <tbody @click="handleClick">
            </tbody>
        </table>
        <div class="modal" tabindex="-1" role="dialog" ref="formDialog" data-backdrop="static">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <form role="form" @submit="submitForm">
                        <div class="modal-header">
                            <h4 class="modal-title">{{ formTitle }}</h4>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body row">
                            <p v-if="errors.length" class="alert alert-danger">
                                <b>Please correct the following error(s):</b>
                                <ul>
                                    <li v-for="error in errors">{{ error }}</li>
                                </ul>
                            </p>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Nama Sekolah</label>
                                <input type="hidden" name="row_id" value="" v-model="form.id"/>
                                <input id="name" class="form-control name" v-model="form.name" type="text" required="required" name="name" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Alamat</label>
                                <textarea class="form-control" v-model="form.address"></textarea>
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Website</label>
                                <input id="website" class="form-control website" v-model="form.website" type="text" required="required" name="website" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Telp Sekolah</label>
                                <input id="phone" class="form-control phone" v-model="form.phone" type="text" required="required" name="phone" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Email Sekolah</label>
                                <input id="email" class="form-control email" v-model="form.email" type="email" required="required" name="email" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Nama Guru 1</label>
                                <input id="cp_name" class="form-control cp_name" v-model="form.cp_name" type="text" required="required" name="cp_name" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Jabatan Guru 1</label>
                                <input id="cp_role" class="form-control cp_role" v-model="form.cp_role" type="text" required="required" name="cp_role" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Phone 1</label>
                                <input id="cp_phone" class="form-control cp_phone" v-model="form.cp_phone" type="number" required="required" name="cp_phone" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Email Guru 1</label>
                                <input id="cp_email" class="form-control cp_email" v-model="form.cp_email" type="text" required="required" name="cp_email" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Nama Guru 2</label>
                                <input id="cp_name2" class="form-control cp_name2" v-model="form.cp_name2" type="text" required="required" name="cp_name2" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Jabatan Guru 2</label>
                                <input id="cp_role2" class="form-control cp_role2" v-model="form.cp_role2" type="text" required="required" name="cp_role2" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Phone 2</label>
                                <input id="cp_phone2" class="form-control cp_phone2" v-model="form.cp_phone2" type="number" required="required" name="cp_phone2" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Email Guru 2</label>
                                <input id="cp_email2" class="form-control cp_email2" v-model="form.cp_email2" type="text" required="required" name="cp_email2" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Nama Guru 3</label>
                                <input id="cp_name3" class="form-control cp_name3" v-model="form.cp_name3" type="text" required="required" name="cp_name3" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Jabatan Guru 3</label>
                                <input id="cp_role3" class="form-control cp_role3" v-model="form.cp_role3" type="text" required="required" name="cp_role3" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Phone 3</label>
                                <input id="cp_phone3" class="form-control cp_phone3" v-model="form.cp_phone3" type="number" required="required" name="cp_phone3" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Email Guru 3</label>
                                <input id="cp_email3" class="form-control cp_email3" v-model="form.cp_email3" type="text" required="required" name="cp_email3" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Nama Guru 4</label>
                                <input id="cp_name4" class="form-control cp_name4" v-model="form.cp_name4" type="text" required="required" name="cp_name4" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Jabatan Guru 4</label>
                                <input id="cp_role4" class="form-control cp_role4" v-model="form.cp_role4" type="text" required="required" name="cp_role4" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Phone 4</label>
                                <input id="cp_phone4" class="form-control cp_phone4" v-model="form.cp_phone4" type="number" required="required" name="cp_phone4" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Email Guru 4</label>
                                <input id="cp_email4" class="form-control cp_email4" v-model="form.cp_email4" type="text" required="required" name="cp_email4" />
                            </div>
                        </div>
                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-primary">Save changes</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
    <!-- /.content -->
</template>
<script>
import { createTable, authFetch } from '@/libs/hxcore';
import $ from 'jquery';
import vSelect from 'vue-select';
import "vue-select/dist/vue-select.css";
export default {
    name: 'DataSekolah',
    components: {
        vSelect,
    },
    data() {
        return {
            errors: [],
            method: '',
            roles: '',
            formTitle: 'Tambah',
            form: {
                name: '',
                address: '',
                website: '',
                phone: '',
                email: '',
                cp_name: '',
                cp_role: '',
                cp_email: '',
                cp_phone: '',
                cp_name2: '',
                cp_role2: '',
                cp_email2: '',
                cp_phone2: '',
                cp_name3: '',
                cp_role3: '',
                cp_email3: '',
                cp_phone3: '',
                cp_name4: '',
                cp_role4: '',
                cp_email4: '',
                cp_phone4: '',
            },
        }
    },
    created: function() {
        this.roles = this.$route.meta.roles;
        console.log('load initial data', this.$route)
    },
    methods: {
        handleClick(e) {
            if (e.target.matches('.link-role')) {
                this.$router.push({ path: '/permit/' + e.target.dataset.id })
                return false;
            }
        },
        submitForm: function(ev) {
            const e = this.$refs;
            
            var data = Object.keys(this.form).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(this.form[key])).join('&')
            var urlSubmit = '/pr/data_sekolah';
            if (this.method == 'PUT') urlSubmit = '/pr/data_sekolah/' + this.form.id;

            authFetch(urlSubmit, {
                    method: this.method,
                    body: data
                })
                .then(res => {
                    if (res.status === 201) {

                    } else if (res.status === 400) {}
                    return res.json();
                })
                .then(js => {

                    this.errors = [];
                    if (!js.success) {
                        console.log(js.details)

                        for (var key in js.details) {
                            if (js.details.hasOwnProperty(key)) {
                                this.errors.push(js.details[key])
                            }
                        }

                        return;
                    }
                    this.table.api().ajax.reload();
                    $(e.formDialog).modal('hide');
                });

            ev.preventDefault();
        }
    },
    mounted() {
        const e = this.$refs;
        var self = this;
        this.table = createTable(e.tableuser, {
            "title": "List Data Sekolah",
            "roles": this.$route.params.roles,
            "ajax": "/pr/data_sekolah",
            "scrollX": true,
            "columns": [
                { "data": "name" },
                { "data": "address" },
                { "data": "website" },
                { "data": "phone" },
                { "data": "email" },
                { "data": "guru1",
                render: function (data, type, row, meta) {
                    return `${row.cp_name}<br>${row.cp_role}<br>${row.cp_phone}<br>${row.cp_email}`;
                }, },
                { "data": "guru2",
                render: function (data, type, row, meta) {
                    return `${row.cp_name2}<br>${row.cp_role2}<br>${row.cp_phone2}<br>${row.cp_email2}`;
                }, },
                { "data": "guru3",
                render: function (data, type, row, meta) {
                    return `${row.cp_name3}<br>${row.cp_role3}<br>${row.cp_phone3}<br>${row.cp_email3}`;
                }, },
                { "data": "guru4",
                render: function (data, type, row, meta) {
                    return `${row.cp_name4}<br>${row.cp_role4}<br>${row.cp_phone4}<br>${row.cp_email4}`;
                }, },
            ],
            filterBy: [0],
            "rowCallback": function(row, data) {
            },
            buttonClick: (evt) => {
                if (evt.role == 'create') {
                    self.form = {};
                    self.method = 'POST';
                    self.errors = [];
                    self.formTitle = 'Tambah Data Sekolah';
                    $(e.formDialog).modal('show');
                } else if (evt.role == 'update' && evt.data) {
                    self.form = evt.data;
                    self.method = 'PUT';
                    self.errors = [];
                    self.formTitle = 'Edit Data Sekolah';
                    $(e.formDialog).modal('show');
                } else if (evt.role == 'delete' && evt.data) {
                self.form = evt.data;
                authFetch('/pr/data_sekolah/' + evt.data.id, {
                        method: 'DELETE',
                        body: 'id=' + evt.data.id
                    })
                    .then(res => {
                        return res.json();
                    })
                    .then(js => {
                        this.table.api().ajax.reload();
                    });
                }

            },
        });

    }
}
</script>